import FnrFetch3, { callMockResponse } from "Utilities/FnrFetch/FnrFetch3";
import { fnThrowError } from "Utilities/fnReportError";

import { mockData } from "./mockData";

export const saveDefaultFilter = async ({ boardID, groupID, filters }) => {
  // const endpoint = `/board/${boardID}/saveDefaultFilter`;
  const endpoint = `/board/saveDefaultFilter`;
  const fetchFunction = mockData.shouldMock
    ? callMockResponse(mockData.saveDefaultFilter)
    : new FnrFetch3(endpoint, { boardID, groupID, filters });

  const response = await fetchFunction.post().catch((err) =>
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    })
  );

  return response;
};

export const archiveBoard = async ({ boardID, archive }) => {
  const endpoint = `/board/` + boardID + `/archiveBoard`;
  const fetchFunction = mockData.shouldMock
    ? callMockResponse(mockData.archiveBoard)
    : new FnrFetch3(endpoint, { boardID, archive });

  const response = await fetchFunction.post().catch((err) =>
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    })
  );

  return response;
};

export const deleteBoard = async ({ boardID, groupURL }) => {
  const endpoint = `/board/${boardID}/deleteBoard`;
  const fetchFunction = mockData.shouldMock
    ? callMockResponse(mockData.deleteBoard)
    : new FnrFetch3(endpoint, { groupURL });

  const response = await fetchFunction.post().catch((err) =>
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    })
  );

  return response;
};

export const getAllAvailableBoards = async ({ columnID, currentBoardID }) => {
  const endpoint = `/board/getAvailableBoardsToAddColumnTo?columnID=${columnID}&currentBoardID=${currentBoardID}`;

  const fetchFunction = mockData.shouldMock
    ? callMockResponse(mockData.getAllAvailableBoards)
    : new FnrFetch3(endpoint);

  const response = await fetchFunction
    .get()
    .catch((err) => fnThrowError({ message: `Error at ${endpoint}: ${err}` }));

  return response;
};

export const getSacramentStructures = async ({ boardID }) => {
  const endpoint = `/extendedField/structures/sacraments/boards/${boardID}`;
  const fetchFunction = mockData.shouldMock
    ? callMockResponse(mockData.getSacramentStructures)
    : new FnrFetch3(endpoint);

  const response = await fetchFunction.get().catch((err) =>
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    })
  );

  return response;
};

export const linkColumnToBoard = async ({
  boardID,
  groupID,
  linkColumnID,
  order = -1,
}) => {
  const endpoint = `/board/${boardID}/linkColumnToBoard`;

  const fetchFunction = mockData.shouldMock
    ? callMockResponse(mockData.linkColumnToBoard)
    : new FnrFetch3(endpoint, { groupID, linkColumnID, order });

  const response = await fetchFunction.post().catch((err) => {
    fnThrowError({ message: `Error at ${endpoint}: ${err}` });
  });

  return response;
};

export const addColumn = async ({ boardID, postData }) => {
  const endpoint = `/board/${boardID}/addColumn`;
  const mutationFunction = mockData.shouldMock
    ? callMockResponse(mockData.addColumn)
    : new FnrFetch3(endpoint, postData);

  const response = await mutationFunction.post().catch((err) =>
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    })
  );

  return response;
};
